import { getNamespace } from '../utils/namespace'

export default {
  getDictData: {
    path: getNamespace() + '/api/open/dictionary/list',
    method: 'get'
  },
  listDict: {
    path: getNamespace() + '/api/open/dict/list',
    method: 'post',
    comment: '查询字典'
  },
  // V1.5.0.0 登录流程修改涉及api
  getTenantListByMobile: {
    path: getNamespace() + '/auth/mobile/before/login',
    method: 'post'
  }
}



// WEBPACK FOOTER //
// ./src/apis/app.js